import { TableNumberButton } from '$globalStyledComponents/Table'
import { Progress, Tag } from 'antd'
import Tooltip from '$components/Tooltip'
import { convertToPercentage } from '$utils'
import { dateWithTimeRenderer } from '$utils/i18n'
import TruncateText from '$components/TruncateText'

const createColumns = (t, progressColor) => {
  const columns = [
    {
      title: t('bookedservices.client_company'),
      dataIndex: 'company',
      sorter: true,
      render: (title) => (
        <TruncateText text={title.slice(1)} useLineClamp={true} />
      ),
      ellipsis: true,
    },
    {
      title: t('bookedservices.service_name'),
      dataIndex: 'service_name',
      sorter: true,
      render: (title) => <TruncateText text={title} />,
      ellipsis: true,
    },
    {
      title: t('Part No'),
      dataIndex: 'part.id_part_client',
      sorter: true,
      width: '160px',
      render: (_, bookedService) => (
        <TableNumberButton>
          {bookedService.part.id_part_client}
        </TableNumberButton>
      ),
    },
    {
      title: t('Part Name'),
      dataIndex: 'part.name',
      sorter: true,
      render: (_, bookedService) => (
        <TruncateText text={bookedService.part.name} />
      ),
      ellipsis: true,
    },
    {
      title: t('Material'),
      render: (record) => {
        if (record.part) {
          const materialName = record.part.client_material_name || '–'
          return <TruncateText text={materialName} />
        }
        return '–'
      },
      ellipsis: true,
    },
    {
      title: t('bookedservices.date_of_request'),
      dataIndex: 'time_stamp',
      sorter: true,
      defaultSortOrder: 'descend',
      width: '6% !important',
      render: (time_stamp) => dateWithTimeRenderer(t)(time_stamp),
    },
    {
      title: t('Progress'),
      progress: '',
      width: '22%',
      render: (record) =>
        record?.status_info !== 'rejected' ? (
          <Progress
            percent={convertToPercentage(record.status_info)}
            size="small"
            strokeColor={progressColor(convertToPercentage(record.status_info))}
          />
        ) : (
          <Tooltip title={t('bookedservices.rejected_by_provider')}>
            <Tag color="red">
              <TruncateText text={t('bookedservices.order_rejected')} />
            </Tag>
          </Tooltip>
        ),
    },
  ]

  return columns
}

export default createColumns
